import { onSnapshot } from 'firebase/firestore';
import { buildLeadsQuery } from '../leadQuery';

// Live tenant/role-scoped leads listener. Returns an unsubscribe fn.
// onChange(leads) fires on every snapshot; onError(err) on permission/other errors.
export function subscribeLeads({ tenantId, role, territoryIds }, onChange, onError) {
  if (!tenantId) {
    onChange([]);
    return () => {};
  }
  // Agents/managers are territory-scoped: with no territories (or before the
  // profile finishes loading) they can read nothing — never issue an unscoped
  // query, which the rules would reject doc-by-doc as a confusing "list" error.
  if ((role === 'agent' || role === 'manager') && (territoryIds?.length ?? 0) === 0) {
    onChange([]);
    return () => {};
  }
  const q = buildLeadsQuery({ tenantId, role, territoryIds });
  return onSnapshot(
    q,
    (snap) => onChange(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    (err) => (onError ? onError(err) : console.error('leads listener error', err)),
  );
}
